import React from "react";
import { compose } from "redux";
import connected from "./connected";
import DaysSelect from "../../components/DaysSelect";
import TimeSelect from "../../components/TimeSelect";
import ZoneSelect from "../../components/ZoneSelect";
import ResetSelect from "../../components/ResetSelect";
import s from "./index.css";

const ConnectedDays = connected(DaysSelect);

export default () => (
  <div className={s.content}>
    <ConnectedDays />
    <TimeSelect />
    <ZoneSelect />
    {/* <ResetSelect /> */}
    <div className="d-block m-4" />
  </div>
);



// WEBPACK FOOTER //
// ./src/routes/Home/index.js